/**
 * Импорт компонентов.
 */
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import CryptoSwiper from './components/swiper-crypto.js';
import TopAuthorsSwiper from './components/swiper-top-authors.js';
import CategoriesNav from './components/categories-nav.js';
import MobileNav from './components/mobile-nav.js';
import PostSortSelect from './components/post-sort-select.js';
import SearchOverlay from './components/search-overlay.js';
import SearchTopicFilter from './components/search-topic-filter.js';
import ThemeColorTurn from './components/theme-color-turn.js';
import CookiesCard from './components/cookies-card.js';
import CryptocoinWidget from './components/cryptocoin-widget.js';

Swiper.use([Navigation, Pagination]);
window.Swiper = Swiper;

/**
 * Инициализация компонентов при загрузке DOM.
 */
document.addEventListener('DOMContentLoaded', function() {
    new CryptoSwiper();
    new TopAuthorsSwiper();
    new CategoriesNav();
    new MobileNav();
    new PostSortSelect();
    new SearchOverlay();
    new SearchTopicFilter();
    new ThemeColorTurn();
    new CookiesCard();
    new CryptocoinWidget();
});
